import router from '@/router/index'
import http from './http'

function jsonp(url) {
    return new Promise((resolve, reject) => {
        const callbackName = `jsonp_callback_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        const script = document.createElement('script')
        script.src = `${url}&callback=${callbackName}&output=jsonp`
        script.type = 'text/javascript'

        const timeout = setTimeout(() => {
            reject(new Error('JSONP request timeout'))
            cleanup()
        }, 8000)

        function cleanup() {
            clearTimeout(timeout)
            if (script.parentNode) {
                try {
                    document.body.removeChild(script)
                } catch (e) { }
            }
            if (typeof window[callbackName] === 'function') {
                delete window[callbackName]
            }
        }

        script.onerror = () => {
            reject(new Error('JSONP request failed'))
            cleanup()
        }

        script.onload = () => {
            setTimeout(() => {
                if (typeof window[callbackName] === 'undefined') {
                    reject(new Error('JSONP callback not called'))
                    cleanup()
                }
            }, 100)
        }

        window[callbackName] = (data) => {
            if (data && data.status === 0) {
                resolve(data)
            } else {
                reject(new Error(`API error: ${data && data.message || 'unknown'}`))
            }
            cleanup()
        }

        document.body.appendChild(script)
    })
}

function getMockLocation() {
    return {
        content: {
            ip: '192.168.1.1',
            address_detail: {
                country: 'China',
                province: 'Hong Kong',
                city: 'Hong Kong'
            },
            point: {
                x: '114.17',
                y: '22.31'
            }
        },
        status: 0
    }
}

export async function getLocationInfo(route) {
    // const url = `https://api.map.baidu.com/location/ip?ak=SNmW5TcarlPfd4zM0R0MF4EsE6L666xJ&coor=bd09ll`
    // let res

    // try {
    //     res = await jsonp(url)
    // } catch (err) {
    //     console.warn('JSONP request failed, using mock data:', err.message)
    //     res = getMockLocation()
    // }

    try {
        // const data = res.content

        // let addressInfo = {
        //     country: '',
        //     province: '',
        //     city: '',
        //     lng: '',
        //     lat: ''
        // }
        // console.log(res, '000---获取位置信息')
        // addressInfo.ip = data.ip ? data.ip : ''
        // addressInfo.country = data.address_detail && data.address_detail.country ? data.address_detail.country : ''
        // addressInfo.province = data.address_detail && data.address_detail.province ? data.address_detail.province : ''
        // addressInfo.city = data.address_detail && data.address_detail.city ? data.address_detail.city : ''
        // addressInfo.lng = data.point && data.point.x ? data.point.x : ''
        // addressInfo.lat = data.point && data.point.y ? data.point.y : ''

        http.getIP().then(addressInfo => {
            // console.log(res, '---获取IP')
            http.statistics_add({
                Ip: addressInfo.Ip,
                country: addressInfo.country,
                country_en: addressInfo.country_en,
                city: addressInfo.city,
                province: addressInfo.province,
                times:addressInfo.times,
                longitude: addressInfo.lng,
                latitude: addressInfo.lat,
                pages: route.path,
                title: route.name,
                create_time: new Date().getTime()
            }).then(aaa => {
                console.log(aaa, '---统计结果')
            })
        })
    } catch (err) {
        console.error('处理位置数据失败', err)
    }
}


// WEBPACK FOOTER //
// ./src/utils/location.js